module.exports = __webpack_public_path__ + "img/05_zhCn.417520bc.png";